import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import s from './PopoverRootLayout.scss';
/** Our standard Popover layout, included at the root of the content. */
var PopoverRootLayout = function (_a) {
    var header = _a.header, preamble = _a.preamble, content = _a.content, footer = _a.footer, className = _a.className, contentClassName = _a.contentClassName, showHeaderBorder = _a.showHeaderBorder, showFooterBorder = _a.showFooterBorder;
    return (React.createElement(Section, { className: c(s['root'], className) },
        React.createElement("div", { className: c(s['header-and-preamble-wrapper'], showHeaderBorder && s['border']) },
            React.createElement("div", { className: s['header-wrapper'] }, header),
            // No need for a wrapper, the spec doesn't have defined paddings for this guy.
            // We'll rely on the consumer to lay this out right.
            preamble),
        React.createElement("div", { className: c(s['content-wrapper'], contentClassName) }, content),
        React.createElement("div", { className: c(s['footer-wrapper'], showFooterBorder && s['border']) }, footer)));
};
PopoverRootLayout.displayName = 'PopoverRootLayout';
export default PopoverRootLayout;
//# sourceMappingURL=PopoverRootLayout.js.map